import React, { useState, useEffect } from "react";

import Loader from "utilities/Loader";

import { getModalInfo, getTours, getReservation } from "services/reservation";
import { getFilterMax } from "services/adminTourList";

const ReservationContext = React.createContext({
  reservations: [
    {
      id: -1,
      mtm: 0,
      tour: {
        id: -1,
        title: "",
        mainprice: 0,
        main_status: 0,
      },
      buyer: {
        id: -1,
        fullname: "",
      },
      passangers: [
        {
          id: -1,
          fullname: "",
        },
      ],
      factor: {
        id: -1,
        total_amt: 0,
        total_count: 0,
        total_discount: 0,
        total_paid: 0,
      },
      additionalCost: [
        {
          id: 0,
          title: "",
          cost: 0,
          discount: 0,
        },
      ],
    },
  ],
  editModalData: {
    userOptions: [],
    AC: [],
  },
  editModalDynamicData: {
    selectedUsers: { value: -1, label: "" },
    selectedEscort: [],
    tourDiscount: 0,
    tourPrice: 0,
    totalPrice: 0,
    SAC: {
      id: -1,
      price: 0,
      discount: 0,
      totalPrice: 0,
    },
  },
  tours: [
    {
      id: -1,
      title: "",
      duration: "",
      transferType: "",
      passangers: [
        {
          id: -1,
          fullname: "",
          codemelli: "",
          mobile: "",
        },
      ],
    },
  ],
  maxPrice: 0,
  MDataHandler: (key, value) => {},
  MDDataHandler: (key, value) => {},
  getModalData: (id, type) => {},
  getInfo: (conditions) => {},
});
export default ReservationContext;

export function ReservationContextProvider({ children }) {
  const [reservations, setReservations] = useState([]);
  const [editModalData, setEditModalData] = useState({
    userOptions: [],
    AC: [],
  });
  const [editModalDynamicData, setEditModalDynamicData] = useState({
    selectedUsers: { value: -1, label: "" },
    selectedEscort: [],
    tourDiscount: 0,
    tourPrice: 0,
    totalPrice: 0,
    SAC: {
      id: -1,
      price: 0,
      discount: 0,
      totalPrice: 0,
    },
  });
  const [tours, setTours] = useState([]);
  const [maxPrice, setMaxPrice] = useState(0);
  const [loading, setLoading] = useState(true);

  function editModalDataHandler(key, value) {
    setEditModalData({ ...editModalData, [key]: value });
  }

  function editModalDynamicDataHandler(key, value) {
    setEditModalDynamicData({ ...editModalDynamicData, [key]: value });
  }

  function getModalData(id, type = 1) {
    const TYPES = {
      1: "edit",
      2: "save",
    };
  }

  async function getInfo(conditions) {
    let res = await getTours(conditions);
    setTours(res);
  }

  useEffect(() => {
    async function loadPage() {
      let res;
      res = await getReservation();
      setReservations(res);
      res = await getModalInfo();
      setEditModalData({
        userOptions: res.users,
        AC: res.additionalCost,
      });
      await getInfo();
      res = await getFilterMax();
      setMaxPrice(maxPrice);

      setLoading(false);
    }
    loadPage();
  }, []);

  return (
    <ReservationContext.Provider
      value={{
        reservations,
        editModalData,
        editModalDynamicData,
        tours,
        maxPrice,
        MDataHandler: editModalDataHandler,
        MDDataHandler: editModalDynamicDataHandler,
        getModalData,
        getInfo,
      }}
    >
      {loading ? <Loader /> : ""}
      {children}
    </ReservationContext.Provider>
  );
}
